/** Estado significativo en la URL (spec §7.2, §9.4): lugar, mención y párrafo de lectura. */
export interface UrlSelection {
  place: string | null;
  mention: string | null;
  paragraph: string | null;
}

const PLACE = /^place-(?:sal|avi|seg)-[a-z0-9-]+$/;
const PARA = /^(?:sal|avi|seg)-c\d{2}(-s\d{2})?-p\d{3}(-n\d+)?$/;
const MENTION = /^(?:sal|avi|seg)-c\d{2}(-s\d{2})?-p\d{3}(-n\d+)?-m\d{2}$/;

/** Lee y sanea los parámetros; un valor con formato inválido se descarta en lugar de romper la vista. */
export function readSelection(params: URLSearchParams): UrlSelection {
  const pick = (k: string, re: RegExp) => {
    const v = params.get(k);
    return v && re.test(v) ? v : null;
  };
  return { place: pick('place', PLACE), mention: pick('mention', MENTION), paragraph: pick('paragraph', PARA) };
}

/** Devuelve nuevos parámetros aplicando un cambio parcial; conserva el resto (p. ej. filtros). */
export function writeSelection(params: URLSearchParams, patch: Partial<UrlSelection>): URLSearchParams {
  const next = new URLSearchParams(params);
  for (const [k, v] of Object.entries(patch)) {
    if (v) next.set(k, v);
    else next.delete(k);
  }
  return next;
}

export interface Filters {
  type: string | null;
  status: string | null;
  precision: 'located' | 'unlocated' | null;
}

export function readFilters(params: URLSearchParams): Filters {
  const precision = params.get('loc');
  return {
    type: params.get('tipo'),
    status: params.get('estado'),
    precision: precision === 'located' || precision === 'unlocated' ? precision : null,
  };
}
